import { render, staticRenderFns } from "./FoodcourtOrderStatusBoard.vue?vue&type=template&id=2f6e2718&scoped=true"
import script from "./FoodcourtOrderStatusBoard.vue?vue&type=script&lang=js"
export * from "./FoodcourtOrderStatusBoard.vue?vue&type=script&lang=js"
import style0 from "./FoodcourtOrderStatusBoard.vue?vue&type=style&index=0&id=2f6e2718&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6e2718",
  null
  
)

export default component.exports